import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloudUpload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: "256pt",
	height: "256pt",
	viewBox: "0 0 256 256",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "surface1",
		children: /* @__PURE__ */ _jsx("path", {
			style: {
				stroke: "none",
				fillRule: "nonzero",
				fill: "currentColor",
				fillOpacity: 1
			},
			d: "M 128 96 L 80 144 L 112 144 L 112 224 L 144 224 L 144 144 L 176 144 Z M 208 80 C 205.8125 80 203.71875 80.351562 201.59375 80.640625 C 189.40625 52.046875 161.03125 32 128 32 C 94.960938 32 66.609375 52.046875 54.398438 80.640625 C 52.289062 80.351562 50.195312 80 48 80 C 21.484375 80 0 101.5 0 128 C 0 154.515625 21.484375 176 48 176 C 53.132812 176 57.96875 174.9375 62.59375 173.390625 C 71.117188 182.84375 82.828125 189.1875 96 191.125 L 96 174.8125 C 83.539062 172.21875 73.101562 164.109375 67.84375 152.875 C 62.382812 157.25 55.554688 160 48 160 C 30.335938 160 16 145.65625 16 128 C 16 110.335938 30.335938 96 48 96 C 54.320312 96 60.15625 97.890625 65.101562 101.039062 C 70.335938 70.945312 96.398438 48 128 48 C 159.625 48 185.4375 71.054688 190.625 101.1875 C 195.625 97.9375 201.59375 96 208 96 C 225.65625 96 240 110.335938 240 128 C 240 145.65625 225.65625 160 208 160 C 205.4375 160 203 159.625 200.59375 159.0625 C 193.359375 169.28125 181.484375 176 168 176 C 165.234375 176 162.59375 175.59375 160 175 L 160 191.234375 C 162.609375 191.65625 165.265625 192 168 192 C 183.296875 192 197.125 185.828125 207.25 175.890625 C 207.5 175.890625 207.71875 176 208 176 C 234.515625 176 256 154.515625 256 128 C 256 101.5 234.515625 80 208 80 Z M 208 80 "
		})
	})]
});
const ForwardRef = forwardRef(SvgCloudUpload);
export default ForwardRef;
